export default __webpack_public_path__ + "static/media/empty-icon.1a51d8df.png";